export interface ExcelColors {
    value: ExcelColorsValues
    label: ExcelColorsLabels
}

export enum ExcelColorsLabels {
    BLACK = 'BLACK',
    WHITE = 'WHITE',
    RED = 'RED',
    BRIGHT_GREEN = 'BRIGHT_GREEN',
    BLUE = 'BLUE',
    YELLOW = 'YELLOW',
    PINK = 'PINK',
    TURQUOISE = 'TURQUOISE',
    DARK_RED = 'DARK_RED',
    GREEN = 'GREEN',
    DARK_BLUE = 'DARK_BLUE',
    DARK_YELLOW = 'DARK_YELLOW',
    VIOLET = 'VIOLET',
    TEAL = 'TEAL',
    GREY_25_PERCENT = 'GREY_25_PERCENT',
    GREY_50_PERCENT = 'GREY_50_PERCENT',
    CORNFLOWER_BLUE = 'CORNFLOWER_BLUE',
    MAROON = 'MAROON',
    LEMON_CHIFFON = 'LEMON_CHIFFON',
    LIGHT_TURQUOISE1 = 'LIGHT_TURQUOISE1',
    ORCHID = 'ORCHID',
    CORAL = 'CORAL',
    ROYAL_BLUE = 'ROYAL_BLUE',
    LIGHT_CORNFLOWER_BLUE = 'LIGHT_CORNFLOWER_BLUE'
}

export enum ExcelColorsValues {
    BLACK = '#000000',
    WHITE = '#ffffff',
    RED = '#ff0000',
    BRIGHT_GREEN = '#00ff00',
    BLUE = '#0000ff',
    YELLOW = '#ffff00',
    PINK = '#ff00ff',
    TURQUOISE = '#00ffff',
    DARK_RED = '#800000',
    GREEN = '#008000',
    DARK_BLUE = '#000080',
    DARK_YELLOW = '#808000',
    VIOLET = '#800080',
    TEAL = '#008080',
    GREY_25_PERCENT = '#c0c0c0',
    GREY_50_PERCENT = '#808080',
    CORNFLOWER_BLUE = '#9999ff',
    MAROON = '#993366',
    LEMON_CHIFFON = '#ffffcc',
    LIGHT_TURQUOISE1 = '#ccffff',
    ORCHID = '#660066',
    CORAL = '#ff8080',
    ROYAL_BLUE = '#0066cc',
    LIGHT_CORNFLOWER_BLUE = '#ccccff'
}

const defaultFontColor = {
    label: ExcelColorsLabels.WHITE,
    value: ExcelColorsValues.WHITE
} as ExcelColors

const defaultBackgroundColor = {
    label: ExcelColorsLabels.ROYAL_BLUE,
    value: ExcelColorsValues.ROYAL_BLUE
} as ExcelColors

export { defaultBackgroundColor, defaultFontColor }